import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import styles from './Button.module.scss';
const Button = (props) => {
    const { type = 'button', to, color = 1, onClick, className, text, height = 'xs', size = 'xs', icon, borderRadius, disabled } = props;
    const Tag = type === 'NavLink' ? NavLink : `button`;
    const buttonType = type === 'button' || type === 'delete'
        ? 'button'
        : type === 'submit'
            ? 'submit'
            : undefined;
    return (_jsxs(Tag, Object.assign({ "data-testid": `button-${buttonType}`, to: to || '', type: buttonType, className: cn(styles.element, 'd-inline-flex align-items-center justify-content-center text-center', styles[`hasColor-${color}`], styles[`hasHeight-${height}`], styles[`hasSize-${size}`], borderRadius && styles.borderRadius, disabled && styles.disabled, className), onClick: onClick }, { children: [icon && _jsx("span", Object.assign({ className: styles.icon }, { children: icon })), text] })));
};
export default Button;
